import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=d287d6b0&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=d287d6b0&prod&lang=scss&scoped=true"
import style1 from "./Summary.vue?vue&type=style&index=1&id=d287d6b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d287d6b0",
  null
  
)

export default component.exports